export default __webpack_public_path__ + "static/media/tp_loader.dcadc957.gif";